var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "left-wrap" }, [
    _c(
      "ul",
      { staticClass: "menu-list" },
      [
        _vm.certificationAuth
          ? [
              _c(
                "li",
                { staticClass: "menu-list-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "menu bgh",
                      class: {
                        active:
                          _vm.$route.path.indexOf(
                            "/judicialService/baoguanhan"
                          ) !== -1
                      },
                      attrs: { to: "/judicialService/baoguanhan" }
                    },
                    [_vm._v("保管函")]
                  )
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "menu-list-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "menu ezj",
                      class: {
                        active:
                          _vm.$route.path.indexOf(
                            "/judicialService/eEvidence"
                          ) !== -1
                      },
                      attrs: { to: "/judicialService/eEvidence" }
                    },
                    [_vm._v("E证据")]
                  )
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "menu-list-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "menu ezj",
                      class: {
                        active:
                          _vm.$route.path.indexOf(
                            "/judicialService/technicalReport"
                          ) !== -1
                      },
                      attrs: { to: "/judicialService/technicalReport" }
                    },
                    [_vm._v("电子签署技术报告")]
                  )
                ],
                1
              )
            ]
          : _vm._e(),
        _vm.arbitrationAuth
          ? _c(
              "li",
              { staticClass: "menu-list-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu ezj",
                    class: {
                      active:
                        _vm.$route.path.indexOf(
                          "/judicialService/applyArbitration"
                        ) !== -1
                    },
                    attrs: { to: "/judicialService/applyArbitration" }
                  },
                  [_vm._v("仲裁管理")]
                )
              ],
              1
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4e9cd30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e9cd30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/judicialService/leftTab.vue
// module id = mbE/
// module chunks = 23 24 27 29 31 50 60 67 68 69 70 71 78 79 80 81 104